import { useTranslation } from 'react-i18next';
import React from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import { map } from 'rxjs';

import { ManageExecution } from '@store/operations/executions';
import { clientsService } from '@store/clients';
import { clientsUnitsService } from '@store/clients/units';
import { Address } from '@store/common/address.model';

import AsyncSelectWithSearchComponent from '@components/inputs/asyncSelect/AsyncSelectWithSearch.component';

import { Sizes } from '@constants/sizes.constants';

interface ClientsDetailsFormProps {
  execution: ManageExecution;
  isCreation?: boolean;
  readOnly?: boolean;
  updateExecution: (data: ManageExecution, field?: string) => void;
  errors: { [key: string]: any };
}

const ClientDetailsForm = (props: ClientsDetailsFormProps) => {
  const { execution, errors, isCreation, readOnly, updateExecution } = props;

  const { t } = useTranslation();

  return (
    <>
      <Stack py="20px" spacing={2}>
        <Typography fontSize={16} fontWeight="700">
          {t('operations.executions.manage.stakeholder')}
        </Typography>
        <Stack spacing={2}>
          <AsyncSelectWithSearchComponent
            color="secondary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('operations.manage.client')}
            placeholder={t('global.selectOption')}
            handleChange={(item) => {
              updateExecution({ organisation: item ? { id: item.value, name: item.label } : undefined }, 'organisation');
            }
            }
            value={{
              label: execution.organisation?.name || '',
              value: execution.organisation?.id
            }}
            getOptions={(search) => clientsService.searchClients(search).pipe(
              map((options) => options.data.map((o) => ({ label: o.name, value: o.id })))
            )}
            error={errors.organisation}
            readOnly={readOnly || !isCreation}
            required />
          <AsyncSelectWithSearchComponent
            color="secondary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('operations.executions.manage.clientSite')}
            placeholder={t('global.selectOption')}
            handleChange={(organisationUnit) =>
              updateExecution({
                organisationUnit: organisationUnit ? {
                  id: organisationUnit.value,
                  name: organisationUnit.label,
                  address: organisationUnit.data.address
                } : undefined,
              }, 'organisationUnit')
            }
            value={execution.organisationUnit ? {
              label: execution.organisationUnit.name,
              value: execution.organisationUnit.id
            } : undefined}
            getOptions={(search) => clientsUnitsService.searchClientsUnits(search, execution.organisation?.id ? [execution.organisation.id] : undefined).pipe(
              map((options) => options.data.map((o) => ({
                label: o.name || '-',
                value: o.id,
                data: {
                  address: {
                    street: o.street,
                    city: o.city,
                    zip: o.zip,
                    country: o.country,
                  } as Address,
                },
              }))),
            )}
            error={errors.organisationUnit}
            disabled={!execution.organisation}
            readOnly={readOnly || !isCreation}
            required />
        </Stack>
      </Stack>
      <Divider variant="fullWidth" orientation="horizontal" />
    </>
  );
};

export default ClientDetailsForm;
